function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleOptimize = function SvgGoogleOptimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.698 3.447a7.283 7.283 0 0 1 7.283 7.212l.013 19.338a7.175 7.175 0 1 1-14.337-.002V17.942H29.106a7.28 7.28 0 0 1-6.556-7.247 7.283 7.283 0 0 1 6.556-7.248h19.592ZM30.866 22.711a7.345 7.345 0 0 1 7.429 7.175l-.002 19.239a7.355 7.355 0 0 1-7.283 7.429 7.04 7.04 0 0 1-6.893-7.429V37.058H11.71V22.71h19.156Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 37.219a7.248 7.248 0 1 0 0-14.496 7.248 7.248 0 0 0 0 14.496Z",
    fill: props.color,
    stroke: props.color
  })));
};
export default SvgGoogleOptimize;